module.exports = __webpack_public_path__ + "img/nota-codigo-farmacias-descuento.839218ef.png";